import { useState } from "react";
import styled from "styled-components";
import { ButtonLink, ButtonRound, HelpIcon } from "@ficatranquilo/contabilidade.com-ui";
import HelpVideoModal from "../HelpVideoModal";
import { TUTORIAL_VIDEOS } from "../../helpers/tutorialVideos";

const Wrapper = styled.span`
    display: inline-block;
    padding-left: 8px;
    line-height: 1;
    vertical-align: middle;
`;

/**
 * Botão de ajuda que abre o(s) tutorial(is) em vídeo da tela.
 *
 * Props:
 * - videoKey: chave (ou array de chaves) em `helpers/tutorialVideos`. Com mais de
 *   uma, o modal abre com a lista para a pessoa escolher.
 * - label: quando informado, vira link de texto (ButtonLink); sem ele, o ButtonRound
 *   com o ícone de ajuda e a dica no title
 */
export default function HelpVideoButton({ videoKey, label }) {
    const [show, setShow] = useState(false);

    const keys = Array.isArray(videoKey) ? videoKey : [videoKey];
    // Chave inexistente é ignorada, para um vídeo removido do catálogo não quebrar a tela
    const videos = keys.map((key) => TUTORIAL_VIDEOS[key]).filter(Boolean);
    if (!videos.length) return null;

    const tooltipText = videos.length > 1 ? "Ver tutoriais em vídeo" : "Ver tutorial em vídeo";

    return (
        <>
            <Wrapper>
                {label ? (
                    <ButtonLink $text={label} $action={() => setShow(true)} />
                ) : (
                    <ButtonRound
                        $variant="outline"
                        $icon={<HelpIcon />}
                        $action={() => setShow(true)}
                        title={tooltipText}
                        aria-label={tooltipText}
                    />
                )}
            </Wrapper>

            <HelpVideoModal show={show} onHide={() => setShow(false)} videos={videos} />
        </>
    );
}
